import { Inserter, Wrapper, SessionRole, PartMenu, DragAndDropContext, ExtensionView } from "nystem-components";
import "./index.css";

const Index = () => (
  <>
    <ExtensionView type="background">
      <SessionRole userrole="logged-in">
        <Inserter source="/denon/extension/upstairs" />
      </SessionRole>
    </ExtensionView>
    <ExtensionView type="popup web">
      <DragAndDropContext>
        <SessionRole userrole="logged-out">
          <PartMenu />
          <Inserter source="/adminUser/login" className="mt-14 max-w-xl px-10 pb-4 text-gray-100" match="*" />
        </SessionRole>
        <SessionRole userrole="logged-in" className="text-base">
          <PartMenu />
          <Wrapper renderAs="main" className="mt-14 max-w-xl pb-4 text-gray-100">
            <Inserter match="/" source="/event/frontAll" />
            <Inserter match="/popup.html" source="/event/frontAll" />
            <Inserter match="/remotorapp/*" source="/device/backlights" />
            <Inserter match="/denon/*" />
            <Inserter match="/energy/*" />
            <Inserter match="/adminUser/*" />
            <Inserter match="/event/*" />
            <Inserter match="/touchscreen/*" />
            <Inserter match="/device/*" />
            <Inserter match="/schedule/*" />
            <Inserter match="/unit/*" />
            <Inserter match="/remotorapp/*" />
          </Wrapper>
        </SessionRole>
      </DragAndDropContext>
    </ExtensionView>
  </>
);

export default Index;
